export const sendContactSuccess = () => {
    return {
        type : 'SEND_CONTACT_SUCCESS'
    }
}

export const sendContact = ({name, mail, message}, funcs) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();    

        const date = new Date().toLocaleString();
        const contactsRef = firebase.ref().child('contacts/');
        const newContactRef = contactsRef.push();
        newContactRef.set({
            name,
            mail,
            message,
            date
        }, () => {
            if(funcs && funcs.successFunc) {
                funcs.successFunc();
            }
        })
    }
}

export const articlesLoadSuccess = (articles) => {
    return { type : 'ARTICLES_LOAD_SUCCESS', payload : { articles } }
}

export const articlesLoadFail = () => {
    return { type : 'ARTICLES_LOAD_FAIL' }
}

export const loadArticles = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const articlesRef = firebase.ref().child('articles');
        articlesRef.orderByChild('date').once('value', (snapshot) => {
            let articles = [];
            snapshot.forEach((article, index) => {
                articles.push({
                    id : article.key,
                    seen : false,
                    ...article.val()
                })
            })
            dispatch(articlesLoadSuccess(articles));
        })
    }
}

export const addArticleView = (article, index) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const articleRef = firebase.ref().child(`articles/${article.id}`);
        articleRef.update({
            view : article.view + 1
        }, () => {
            dispatch(articleSeen(index))
        })
    }
}

export const articleSeen = (index) => {
    return {
        type : 'ARTICLE_SEEN',
        payload : {
            index
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Community/actions/communityActions.js